import LoginView from './LoginView';

/**
 * Session Expired View
 *
 * Shown when a user's authentication token expires while they're using the app.
 * This represents the 'unauthorized' auth status, where Auth0 thinks the user
 * is authenticated but the API returns 401/403.
 *
 * Provides a friendly re-authentication flow that leverages lastUserLogin data
 * to show the user's email/picture and enable one-click smart login.
 */
export const SessionExpiredView = () => {
  return (
    <LoginView
      title="Session Expired"
      subtitle="For your security, your session has ended. Please log in again to continue."
    />
  );
};

export default SessionExpiredView;
